// Reads the (heterogeneously-shaped) travellers jsonb and returns a label
// like "3 Adults 1 Children". Aggregates by travelerTypeId (falls back to
// title), preserving insertion order of first occurrence per type.
export const formatTravellersLabel = (value: unknown): string | null => {
  if (value == null) return null;

  let people: unknown[] | null = null;

  if (typeof value === 'object' && !Array.isArray(value)) {
    const obj = value as Record<string, unknown>;
    if (Array.isArray(obj.people)) {
      people = obj.people;
    } else if (typeof obj.count === 'number' && obj.count > 0) {
      return `${obj.count} ${obj.count === 1 ? 'Adult' : 'Adults'}`;
    }
  } else if (Array.isArray(value)) {
    people = value;
  }

  if (!people || people.length === 0) return null;

  const groups = new Map<string, { label: string; count: number }>();
  for (const p of people) {
    if (p == null || typeof p !== 'object') continue;
    const entry = p as Record<string, unknown>;
    const key =
      (typeof entry.travelerTypeId === 'string' && entry.travelerTypeId) ||
      (typeof entry.title === 'string' && entry.title) ||
      '__unknown__';
    const label = typeof entry.title === 'string' ? entry.title : key;
    const existing = groups.get(key);
    if (existing) existing.count++;
    else groups.set(key, { label, count: 1 });
  }

  const parts = Array.from(groups.values())
    .filter((g) => g.label !== '__unknown__')
    .map((g) => `${g.count} ${g.label}`);

  if (parts.length === 0) {
    const total = people.length;
    return total > 0
      ? `${total} ${total === 1 ? 'Traveller' : 'Travellers'}`
      : null;
  }

  return parts.join(' ');
};
